import { render, staticRenderFns } from "./from.vue?vue&type=template&id=768a6297&scoped=true&"
import script from "./from.vue?vue&type=script&lang=js&"
export * from "./from.vue?vue&type=script&lang=js&"
import style0 from "./from.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./from.vue?vue&type=style&index=1&id=768a6297&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768a6297",
  null
  
)

export default component.exports